import TransporterViewBubble from "./class.TransporterViewBubble";
import ViewController from "./class.ViewController";

/**
 *
 */
export default class TransporterViewLayout extends ViewController {
	/**
	 * A view controller responsible for the layout.
	 * @param {Object} options
	 * @param {*} options.mainController
	 * @param {{}} options.progress
	 * @param {*} options.attributes
	 */
	constructor(options) {
		super(options);
		this.bubbles = [];
	}

	/**
	 * Places a bubble in the layout.
	 * Can be either appended to or inserted after an $anchor.
	 *
	 * @param {*} $anchor
	 * @param {*} method "after" "append"
	 * @param {String} type "teacher" "student" "center"
	 */
	placeBubble($anchor, method, type, virtual = false) {
		var bubbleView = new TransporterViewBubble({
			attributes: {
				mainView: this.mainView,
				className: "aops-transporter-bubble",
				layoutView: this,
				progress: this.progress,
				mainController: this.mainController,
				runnerController: this.runnerController,
				type,
				virtual,
			},
		});

		this.bubbles.push(bubbleView);

		var fn = "append";
		if (method) {
			fn = method;
		} else if ($anchor) {
			if (virtual) {
				fn = "append";
			} else {
				fn = "after";
			}
		}

		if ($anchor.is(this.$el)) {
			this.$el["append"](bubbleView.$el);
		} else {
			($anchor || this.$el)[fn](bubbleView.$el);
		}

		this.mainView.watchHeightReflow();

		return bubbleView;
	}

	getBubble($anchor) {
		return this.bubbles.reduce((prev, curr) => {
			return prev || (curr.$el.is($anchor) && curr);
		}, null);
	}
}
